const mediaQuery = window.matchMedia("(min-width: 769px)");

const getAnimationElements = () => {
  const elements = {
    works: {
      container: document.querySelector(".work-section-container"),
      title: document.querySelector(".text-work-container-desktop"),
      grid: document.querySelector(".works"),
      cards: document.querySelectorAll(".card-work"),
    },
    news: {
      container: document.querySelector(".news-container"),
      title: document.querySelector(".text-news-container"),
      grid: document.querySelector(".news-grid-container"),
    },
  };

  return elements;
};

const validateElements = (elements) => {
  return (
    elements.works.container &&
    elements.works.title &&
    elements.works.grid &&
    elements.news.container &&
    elements.news.title &&
    elements.news.grid
  );
};

const setGsapElements = (elements) => {
  gsap.set(elements.works.title, {
    opacity: 0,
    x: -200,
  });

  gsap.set(elements.works.grid, {
    opacity: 0,
    x: 200,
  });

  gsap.set(elements.news.title, {
    opacity: 0,
    x: 200,
  });

  gsap.set(elements.news.grid, {
    opacity: 0,
    x: -200,
  });
};

const timeline = (
  container,
  title,
  grid,
  duration,
  start,
  end,
  scrub,
  markers = false,
) => {
  return gsap
    .timeline({
      scrollTrigger: {
        trigger: container,
        start: start,
        end: end,
        ...(scrub !== 0 && { scrub: scrub }),
        toggleActions: "play none none reverse",
        markers,
      },
    })
    .to(title, { opacity: 1, x: 0, duration: duration }, "a")
    .to(grid, { opacity: 1, x: 0, duration: duration }, "a");
};

const fadeWorksDesktop = (elements) => {
  timeline(
    elements.works.container,
    elements.works.title,
    elements.works.grid,
    1,
    "top 90%",
    "20% 20%",
    0,
  );
};

const fadeNewsDesktop = (elements) => {
  timeline(
    elements.news.container,
    elements.news.title,
    elements.news.grid,
    1,
    "top 90%",
    "20% 20%",
    0,
  );
};

const initializeFadeAnimations = () => {
  const elements = getAnimationElements();

  if (mediaQuery.matches && validateElements(elements)) {
    setGsapElements(elements);
    fadeWorksDesktop(elements);
    fadeNewsDesktop(elements);
  }
};
export default initializeFadeAnimations;
